import {Component, Inject, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-dead-deal-confirmation',
    templateUrl: './dead-deal-confirmation.component.html',
    styleUrls: ['./dead-deal-confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeadDealConfirmationComponent {
  dealInfo: any;

  constructor(
    private dialogRef: MatDialogRef<DeadDealConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) data: {
      dealInfo: any
    }
  ) {
    this.dealInfo = data ? data.dealInfo : '';
    dialogRef.disableClose = true;
  }
}
